class RecentSearchResults {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/recent-search-results`;
    this.apiClient = apiClient;

  }

  async createRecentSearchResult(recentSearchResult) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, recentSearchResult);

  }

  async getRecentSearchResults(type) {

    const path = `${this.basePath}/:type`;

    return this.apiClient.get(path, { type }, {});

  }

}

export default RecentSearchResults;